import gql from 'graphql-tag';
import { SETUP_INSTRUCTION_CONTROL_PHOTOS_FRAGMENT, SETUP_INSTRUCTION_FRAGMENT } from './setupInstruction';

export const MICROSTORE_COLUMN_SETUP_FRAGMENT = gql`
    fragment MicrostoreColumnSetupFragment on MicrostoreColumnSetup {
        _id
        createdAt
        instructions {
            ...SetupInstructionFragment
        }
        isFinishForced
        isNeeded
        microstoreColumnId
        microstoreColumnInventoryId
        microstoreColumnGroupSetupId
        microstoreLocations {
            microstoreLocationId
            productId
            replacementProductId
            stockToAdd
            expiryDates {
                expiryDate
                quantity
            }
        }
        positionInColumnGroupSetup
        postSiteSetupZeroInventoryProductIds
        state
        stateHistory {
            createdAt
            state
        }
        updatedAt
    }
    ${SETUP_INSTRUCTION_FRAGMENT}
`;

export const MICROSTORE_COLUMN_SETUP_CONTROL_PHOTOS_FRAGMENT = gql`
    fragment MicrostoreColumnSetupControlPhotosFragment on MicrostoreColumnSetup {
        instructions {
            ...SetupInstructionControlPhotosFragment
        }
    }
    ${SETUP_INSTRUCTION_CONTROL_PHOTOS_FRAGMENT}
`;
